import { render, staticRenderFns } from "./NewWebtraderBanner.vue?vue&type=template&id=1aa276dd&scoped=true&"
import script from "./NewWebtraderBanner.vue?vue&type=script&lang=ts&"
export * from "./NewWebtraderBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa276dd",
  null
  
)

export default component.exports